import React from 'react';
import { formatCurrency } from './utils';

export const formatMessageWithCurrency = (text: string): React.ReactNode => {
  if (!text) return text;
  const parts: React.ReactNode[] = [];
  const regex = /(\$[0-9.,]+)/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text))) {
    const idx = match.index;
    if (idx > lastIndex) {
      parts.push(text.slice(lastIndex, idx));
    }
    const raw = match[0];
    const digits = raw.replace(/[^0-9]/g, '');
    const num = digits ? parseInt(digits, 10) : NaN;
    const formatted = !isNaN(num) ? formatCurrency(num) : raw;
    parts.push(<span key={parts.length}>{formatted}</span>);
    lastIndex = idx + raw.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts.length > 0 ? parts : text;
};
